/* Bee Bee · Pop up promocional (eight Digital Studio) */
(function () {
  if (customElements.get('bb-promo-popup')) return;

  function store(type) {
    try { var t = window[type], k = '__bbp'; t.setItem(k, k); t.removeItem(k); return t; } catch (e) { return null; }
  }
  var LS = store('localStorage');
  var SS = store('sessionStorage');

  function parseDate(str, tz) {
    if (!str) return null;
    var m = String(str).trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return null;
    var hh = m[4] ? ('0' + m[4]).slice(-2) : '00';
    var d = new Date(m[1] + '-' + m[2] + '-' + m[3] + 'T' + hh + ':' + (m[5] || '00') + ':00' + (tz || ''));
    return isNaN(d) ? null : d;
  }

  function track(name, detail) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, detail));
    } catch (e) {}
  }

  class BbPromoPopup extends HTMLElement {
    connectedCallback() {
      try { this.cfg = JSON.parse(this.querySelector('[data-bbp-config]').textContent); } catch (e) { return; }
      this.key = 'bbpopup_' + this.cfg.key;
      this.teaser = document.querySelector('[data-bbp-teaser="' + this.id + '"]');
      this.bind();
      this.initCountdowns();

      if (this.cfg.designMode) {
        if (this.cfg.previewInEditor) this.open(true);
        document.addEventListener('shopify:section:select', (e) => { if (this.contains(e.target) || e.target.contains(this)) this.open(true); });
        document.addEventListener('shopify:section:deselect', (e) => { if (this.contains(e.target) || e.target.contains(this)) this.close(true); });
        document.addEventListener('shopify:block:select', (e) => { if (this.contains(e.target)) this.open(true); });
        return;
      }

      if (!this.inDateRange() || !this.deviceOk()) return;
      if (this.cfg.teaser && this.teaser && this.wasDismissed()) this.teaser.classList.add('is-shown');
      if (!this.canShow()) return;
      this.armTrigger();
    }

    bind() {
      this.addEventListener('click', (e) => {
        var copy = e.target.closest('[data-bbp-copy]');
        if (copy) { e.preventDefault(); this.copy(copy); return; }
        var cta = e.target.closest('[data-bbp-cta]');
        if (cta) {
          track('bb_popup_click', { popup_id: this.cfg.key, popup_cta: cta.getAttribute('data-bbp-cta') });
          if (this.cfg.hideAfterClick) this.save({ clicked: true });
          if (cta.hasAttribute('data-bbp-close')) { e.preventDefault(); this.close(); }
          return;
        }
        if (e.target.closest('[data-bbp-close]')) { e.preventDefault(); this.close(); return; }
        if (e.target.closest('[data-bbp-overlay]') && this.cfg.closeOnOverlay) this.close();
      });
      this.onKey = (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); };
      document.addEventListener('keydown', this.onKey);
      if (this.teaser) this.teaser.addEventListener('click', () => this.open(true));
    }

    read() {
      if (!LS) return {};
      try { return JSON.parse(LS.getItem(this.key)) || {}; } catch (e) { return {}; }
    }
    save(patch) {
      if (!LS) return;
      try { LS.setItem(this.key, JSON.stringify(Object.assign(this.read(), patch))); } catch (e) {}
    }
    wasDismissed() { var d = this.read(); return !!(d.closed || d.clicked); }

    inDateRange() {
      var now = new Date();
      var start = parseDate(this.cfg.start, this.cfg.tz);
      var end = parseDate(this.cfg.end, this.cfg.tz);
      if (start && now < start) return false;
      if (end && now >= end) return false;
      return true;
    }
    deviceOk() {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      if (this.cfg.device === 'desktop' && mobile) return false;
      if (this.cfg.device === 'mobile' && !mobile) return false;
      return true;
    }
    canShow() {
      var d = this.read();
      if (this.cfg.hideAfterClick && d.clicked) return false;
      switch (this.cfg.frequency) {
        case 'always': return true;
        case 'session':
          if (!SS) return true;
          return !SS.getItem(this.key);
        case 'once': return !d.shown;
        case 'until_closed': return !d.closed;
        case 'days':
          if (!d.shown) return true;
          return (Date.now() - d.shown) > (Number(this.cfg.frequencyDays) || 1) * 864e5;
      }
      return true;
    }

    armTrigger() {
      var go = () => { if (!this.armed) return; this.armed = false; cleanup(); this.open(); };
      var onScroll = () => {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        var p = h > 0 ? (window.scrollY / h) * 100 : 100;
        if (p >= Number(this.cfg.scroll || 50)) go();
      };
      var onLeave = (e) => { if (e.clientY <= 0 && !e.relatedTarget) go(); };
      var timer = null;
      var cleanup = () => {
        window.removeEventListener('scroll', onScroll);
        document.removeEventListener('mouseout', onLeave);
        if (timer) clearTimeout(timer);
      };
      this.armed = true;
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      switch (this.cfg.trigger) {
        case 'immediately': timer = setTimeout(go, 300); break;
        case 'delay': timer = setTimeout(go, (Number(this.cfg.delay) || 0) * 1000); break;
        case 'scroll': window.addEventListener('scroll', onScroll, { passive: true }); onScroll(); break;
        case 'exit':
          if (mobile) timer = setTimeout(go, (Number(this.cfg.exitMobileFallback) || 15) * 1000);
          else document.addEventListener('mouseout', onLeave);
          break;
        case 'delay_or_scroll':
          timer = setTimeout(go, (Number(this.cfg.delay) || 0) * 1000);
          window.addEventListener('scroll', onScroll, { passive: true });
          break;
      }
    }

    open(force) {
      if (this.classList.contains('is-open')) return;
      this.hidden = false;
      this.classList.add('is-open');
      this.lastFocus = document.activeElement;
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-visible')));
      if (this.cfg.lockScroll && this.classList.contains('bbp--center') && !this.classList.contains('bbp--no-overlay')) {
        document.documentElement.style.overflow = 'hidden';
      }
      if (this.teaser) this.teaser.classList.remove('is-shown');
      var box = this.querySelector('.bbp__box');
      if (box) setTimeout(() => box.focus({ preventScroll: true }), 50);
      if (!force) {
        this.save({ shown: Date.now() });
        if (SS) try { SS.setItem(this.key, '1'); } catch (e) {}
        track('bb_popup_view', { popup_id: this.cfg.key });
        if (Number(this.cfg.autoClose) > 0) this.autoTimer = setTimeout(() => this.close(), Number(this.cfg.autoClose) * 1000);
      }
    }

    close(silent) {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-visible');
      document.documentElement.style.overflow = '';
      if (this.autoTimer) clearTimeout(this.autoTimer);
      setTimeout(() => { this.classList.remove('is-open'); this.hidden = true; }, 300);
      if (!silent && !this.cfg.designMode) {
        this.save({ closed: Date.now() });
        track('bb_popup_close', { popup_id: this.cfg.key });
        if (this.cfg.teaser && this.teaser && this.inDateRange()) this.teaser.classList.add('is-shown');
      }
      if (this.lastFocus && this.lastFocus.focus) try { this.lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }

    copy(btn) {
      var code = btn.getAttribute('data-bbp-copy');
      var label = btn.textContent;
      var done = () => { btn.textContent = btn.getAttribute('data-copied') || '¡Copiado!'; setTimeout(() => { btn.textContent = label; }, 2000); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
      else { var i = document.createElement('input'); i.value = code; document.body.appendChild(i); i.select(); try { document.execCommand('copy'); } catch (e) {} i.remove(); done(); }
      track('bb_popup_copy_code', { popup_id: this.cfg.key, popup_code: code });
    }

    initCountdowns() {
      this.querySelectorAll('[data-bbp-countdown]').forEach((el) => {
        var end = parseDate(el.getAttribute('data-bbp-countdown'), this.cfg.tz);
        if (!end) return;
        var hideOnEnd = el.getAttribute('data-hide-on-end') === 'true';
        var pad = (n) => ('0' + n).slice(-2);
        var iv = null;
        var tick = () => {
          var diff = Math.max(0, end - new Date());
          var s = Math.floor(diff / 1000);
          el.querySelector('[data-d]').textContent = pad(Math.floor(s / 86400));
          el.querySelector('[data-h]').textContent = pad(Math.floor((s % 86400) / 3600));
          el.querySelector('[data-m]').textContent = pad(Math.floor((s % 3600) / 60));
          el.querySelector('[data-s]').textContent = pad(s % 60);
          if (diff <= 0) {
            if (iv) clearInterval(iv);
            if (hideOnEnd && !this.cfg.designMode) { this.expired = true; this.close(true); }
          }
        };
        tick();
        if (!this.expired) iv = setInterval(tick, 1000);
      });
    }
  }
  customElements.define('bb-promo-popup', BbPromoPopup);
})();